import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import { FaTv, FaSave, FaExclamationTriangle, FaVideo, FaClock, FaPlus, FaTrash } from "react-icons/fa";

export default function TransmissaoCircuito() {
  const { circuito } = useOutletContext();
  const [linkTvAoVivo, setLinkTvAoVivo] = useState("");
  const [textoAvisoTv, setTextoAvisoTv] = useState("");
  const [salvando, setSalvando] = useState(false);
  
  // Lista de comerciais dinâmicos
  const [comerciais, setComerciais] = useState([]);

  useEffect(() => {
    if (circuito) {
      setLinkTvAoVivo(circuito.linkTvAoVivo || "");
      setTextoAvisoTv(circuito.textoAvisoTv || "");
      // Carrega os comerciais existentes e adiciona um ID único para o front-end
      if (circuito.comerciais && circuito.comerciais.length > 0) {
        setComerciais(circuito.comerciais.map(c => ({ ...c, id: Math.random(), file: null })));
      }
    }
  }, [circuito]);

  const adicionarComercial = () => {
    setComerciais([...comerciais, { id: Math.random(), video: "", file: null, intervaloMinutos: 15 }]);
  };

  const removerComercial = (id) => {
    setComerciais(comerciais.filter(c => c.id !== id));
  };

  const atualizarComercial = (id, campo, valor) => {
    setComerciais(comerciais.map(c => c.id === id ? { ...c, [campo]: valor } : c));
  };

  const salvarTransmissao = async () => {
    setSalvando(true);
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("linkTvAoVivo", linkTvAoVivo);
      formData.append("textoAvisoTv", textoAvisoTv);

      // Prepara os dados para o backend entender quais são arquivos novos e quais já existiam
      const metadata = comerciais.map((c, i) => ({
        intervaloMinutos: c.intervaloMinutos,
        videoExistente: c.video || null,
        fileIndex: c.file ? i : -1 // Se tiver arquivo novo, marca o índice
      }));
      formData.append("comerciaisMetadata", JSON.stringify(metadata));

      // Anexa os arquivos físicos se houver
      comerciais.forEach((c, i) => {
        if (c.file) {
          formData.append(`video_${i}`, c.file);
        }
      });

      await axios.put(
        `https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/transmissao`,
        formData,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
      );
      alert("📺 Transmissão e Grade de Comerciais atualizados com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar:", error);
      alert("❌ Erro ao salvar a transmissão.");
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="pc-content">
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
        <FaTv size={28} color="#e74c3c" />
        <h1 style={{ margin: 0, color: "#fff" }}>Estúdio de Transmissão</h1>
      </div>

      <div style={{ background: "#1e1e1e", padding: "20px", borderRadius: "12px", border: "1px solid #333", marginBottom: "20px" }}>
        
        {/* SINAL DE TV */}
        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", color: "#ccc", fontWeight: "bold", marginBottom: "8px" }}>Link da Transmissão (YouTube)</label>
          <input type="text" className="jt-input" placeholder="Ex: https://www.youtube.com/watch?v=SEU_VIDEO" value={linkTvAoVivo} onChange={(e) => setLinkTvAoVivo(e.target.value)} style={{ width: "100%", background: "#111", border: "1px solid #444", color: "#fff" }} />
        </div>

        <div style={{ marginBottom: "30px" }}>
          <label style={{ display: "block", color: "#ccc", fontWeight: "bold", marginBottom: "8px" }}>Texto de Aviso no Letreiro</label>
          <input type="text" className="jt-input" value={textoAvisoTv} onChange={(e) => setTextoAvisoTv(e.target.value)} style={{ width: "100%", background: "#111", border: "1px solid #444", color: "#fff" }} />
        </div>

        <hr style={{ borderColor: "#333", marginBottom: "30px" }} />

        {/* MÚLTIPLOS COMERCIAIS */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
          <h3 style={{ color: "#f39c12", display: "flex", alignItems: "center", gap: "8px", margin: 0 }}>
            <FaVideo /> Grade de Comerciais (Overlay)
          </h3>
          <button onClick={adicionarComercial} style={{ background: "#2ecc71", color: "#fff", border: "none", padding: "8px 16px", borderRadius: "6px", cursor: "pointer", fontWeight: "bold", display: "flex", alignItems: "center", gap: "6px" }}>
            <FaPlus /> Adicionar Comercial
          </button>
        </div>

        {comerciais.length === 0 ? (
          <div style={{ color: "#666", textAlign: "center", padding: "20px", background: "#111", borderRadius: "8px" }}>Nenhum comercial configurado.</div>
        ) : (
          comerciais.map((c, index) => (
            <div key={c.id} style={{ display: "flex", gap: "15px", alignItems: "flex-end", background: "#111", padding: "15px", borderRadius: "8px", border: "1px solid #333", marginBottom: "15px", flexWrap: "wrap" }}>
              <div style={{ flex: "1 1 250px" }}>
                <label style={{ display: "block", color: "#ccc", fontSize: "12px", marginBottom: "5px" }}>Vídeo {index + 1} (MP4)</label>
                <input type="file" accept="video/mp4" onChange={(e) => atualizarComercial(c.id, "file", e.target.files[0])} style={{ width: "100%", color: "#fff" }} />
                {c.video && !c.file && <small style={{ color: "#2ecc71", display: "block", marginTop: "4px" }}>✅ Arquivo já salvo ({c.video.slice(0, 15)}...)</small>}
              </div>
              <div style={{ flex: "1 1 120px" }}>
                <label style={{ display: "block", color: "#ccc", fontSize: "12px", marginBottom: "5px" }}><FaClock /> A cada (Minutos)</label>
                <input type="number" min="1" className="jt-input" value={c.intervaloMinutos} onChange={(e) => atualizarComercial(c.id, "intervaloMinutos", e.target.value)} style={{ width: "100%", background: "#222", border: "1px solid #444", color: "#fff" }} />
              </div>
              <button onClick={() => removerComercial(c.id)} style={{ background: "#e74c3c", color: "#fff", border: "none", padding: "10px", borderRadius: "6px", cursor: "pointer", height: "42px" }}>
                <FaTrash />
              </button>
            </div>
          ))
        )}

        <button onClick={salvarTransmissao} disabled={salvando} style={{ background: "#e74c3c", color: "#fff", padding: "12px 24px", borderRadius: "8px", fontWeight: "bold", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px", marginTop: "20px" }}>
          <FaSave /> {salvando ? "Enviando Arquivos..." : "Salvar e Colocar no Ar"}
        </button>
      </div>
    </div>
  );
}